import { Splide } from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function initSlider (): void {
    if (!document.querySelector('.splide')) {
        return;
    }

    const splideContainer = document.querySelector('.splide');
    const isReferenceSlider = splideContainer?.parentNode?.classList.contains('frame-layout-10');
    const slidesPerPage = (isReferenceSlider) ? Math.floor(window.screen.width / 270) : 2;
    const slideGap = (isReferenceSlider) ? '6rem' : '3rem';
    const sliderSpeed = (isReferenceSlider) ? 1.2 : 1;

    const splide = new Splide('.splide', {
        loop: true,
        type: 'loop',
        autoplay: true,
        perPage: slidesPerPage,
        autoWidth: (isReferenceSlider === true),
        gap: slideGap,
        pagination: false,
        drag: true,
        lazyLoad: 'nearby',
        autoScroll: {
            speed: sliderSpeed,
            pauseOnHover: false
        },
    }).mount( { AutoScroll } );
}